<template>
  
  <div v-show="hasSelectedPlan" class="we-selected-plan-card">
    <div class="bg-white flex justify-between border-2 border-primary-brand-100 rounded-xl shadow-sm" :class="classes">
      
      <div v-if="useSmallSelectedPlan" class="flex justify-between w-full">
        <div class="w-full">

          <div class="flex items-start justify-between gap-4">
            <div class="">
              <p class="text-primary-brand-400 font-bold text-base leading-tight">{{ selectedPlan.product?.title }}</p>
              <div class="flex flex-col items-start mt-1">
                  <div v-if="hasDiscount" class="text-primary-brand-200 line-through text-xs flex items-center mr-2">                  
                      R$ {{ originalPriceDisplay }}/mês
                  </div>
                  <div class="text-primary-brand-200 font-semibold text-xs flex items-center mr-3">                  
                      R$ {{ selectedPlan.price?.full_price ?? '' }}/mês
                  </div>
                  <p v-if="promoDescription" class="text-primary-brand-200 text-[11px] leading-tight mt-1">
                    {{ promoDescription }}
                  </p>
              </div> 
            </div>
            <we-button v-if="showChangePlanButton" changePlan label="Trocar" small border-color="primary-brand-100" :loading="isLoading" :icon-options="weButtonIconOptions" @click="openModal"/>
          </div>

          <div v-if="hasCombo" class="mt-3 flex">
            <div
              v-for="(product, index) in selectedPlan.product?.features"
              :key="index"
              class="w-10 h-10 rounded-full bg-white overflow-hidden shrink-0 border-2"
              :class="isBusiness ? 'border-[#A29E9E]' : 'border-secondary-brand-200'"
              :style="{ marginLeft: index === 0 ? '0' : '-8px', zIndex: index }"
            >
                <img :src="product.icon" class="w-full h-full object-cover"/>
            </div>
          </div>
          <div v-else class="mt-3">
            <p class="w-full flex items-center font-medium text-xs text-primary-brand-300">
              {{ selectedPlan.product?.details }}
            </p>
          </div>
          
          
          
        </div>
      </div>

      <div v-else class="flex justify-between flex-col w-full">

        <div class="mb-8">
          <div class="flex flex-col lg:flex-row justify-between gap-4 lg:gap-2 relative">
            <div>
              <p class="text-primary-brand-400 font-extrabold text-3xl lg:pr-24">{{ selectedPlan.product?.title }}</p>
              <p v-if="hasDiscount" class="text-primary-brand-200 font-semibold text-md line-through text-md opacity-60 my-1"> 
                R$ {{ originalPriceDisplay }}/mês</p>
              <p  class="text-primary-brand-200 font-semibold text-2xl">
                  R$ {{ selectedPlan.price?.full_price ?? '' }}/mês
              </p>          
              <p v-if="promoDescription" class="text-primary-brand-200 text-xs leading-snug mt-1">
                {{ promoDescription }}
              </p>
              <p v-if="selectedPlan.product?.mostSold" class="text-primary-brand-300 italic font-medium flex text-sm mt-3">
                <we-icon name="workspace_premium" class="fill-contrast-brand-300 mr-2"/>
                O plano mais vendido do ano!
              </p>
            </div>
            <div class="relative lg:absolute right-0 top-0">
              <we-button v-if="showChangePlanButton" changePlan label="Trocar" small border-color="primary-brand-100" :loading="isLoading" :icon-options="weButtonIconOptions" @click="openModal"/>
            </div>
          </div>
          
        </div>       

        <div v-if="hasCombo">
            <div v-for="(product, index) in selectedPlan.product?.features" :key="index">
              <div class="flex items-center font-semibold text-xl text-primary-brand-300 mb-4">
                  <div 
                    class="w-10 h-10 rounded-full border-2 bg-white mr-2 shrink-0 overflow-hidden"
                    :class="isBusiness ? 'border-[#A29E9E]' : 'border-secondary-brand-200'"
                  >
                    <img :src="product.icon" class="w-full h-full object-cover"/>
                  </div>
                  <span class="leading-none">
                    {{ product.title }}
                  </span>
                  
              </div>
            </div>
        </div>

        <div v-else>
            <div>
              <p class="w-full flex items-center font-medium text-base text-primary-brand-300 mb-4">
                  {{ selectedPlan.product?.details }}
              </p>
            </div>
        </div>

      </div>

    </div>


    <we-informational-card v-if="showInformationalCard" class="mt-4"/>
  </div>

  <div class="selectPlanModal">
    <we-modal v-model="isPlanModalOpen" modal-size="max-w-[90vw] px-10">
      <template #header>
        <div>        
          <div class="font-bold text-2xl text-center" :class="isBusiness ? 'text-gray-800' : 'text-primary-brand-400'">Selecione o plano</div>   
          <div class="text-center mt-2 leading-tight" :class="isBusiness ? 'text-gray-500' : 'text-primary-brand-300'">Com franquia liberada, para navegar e curtir sem preocupação.</div>
          <div class="flex items-center justify-center">
            <div v-if="!isBusiness" class="border border-primary-brand-100 rounded-3xl overflow-hidden flex mx-auto mt-8 mb-10 group is-published w-auto">
              <div class="py-2 px-2 w-44 text-center font-medium cursor-pointer" :class="{ 'bg-secondary-brand-200' : planType === 'plans' }" @click="togglePlanType('plans')">Internet</div>
              <div v-if="availableCombos?.length" class="py-2 px-2 w-44 text-center font-medium cursor-pointer" :class="{ 'bg-secondary-brand-200' : planType === 'combos' }" @click="togglePlanType('combos')">Combos</div>
            </div>            
            <a v-else href="https://weclix.com.br/empresas#plans" target="_blank" class="mt-6">
               <we-button labelClasses="px-2" small no-icon label="Ver todos os planos" class="font-bold text-primary-brand-200"/>
            </a>           
          </div>
        </div>

      </template>
      <template #content>

        <div class="mt-4">

          <div v-if="planType == 'plans'">          
            <we-slider :slider-list-classes="sliderListPositioning" :slider-container-classes="sliderPositioning">
              <div v-for="(plan, index) in availablePlans" :key="index" class="py-6 relative flex justify-center items-start gap-x-5">
                <we-plan-card :plan="plan" @selected-plan="changePlan"/>
              </div>
            </we-slider>
          </div>

          <div v-if="planType == 'combos'">
            <we-slider :slider-list-classes="sliderListPositioning" :slider-container-classes="sliderPositioning">
              <div v-for="(plan, index) in availableCombos" :key="index" class="py-6 relative flex justify-center items-start gap-x-5">
                <we-plan-card :plan="plan" @selected-plan="changePlan"/>
              </div>
            </we-slider>
          </div>

          <p class="text-center text-xs text-primary-brand-200 opacity-60 mt-6 pb-2">
            © Weclix {{ new Date().getFullYear() }} - Todos os direitos reservados. Desenvolvido por <a href="https://zapad.com.br">Zapad</a>
          </p>
        </div>

      </template>
    </we-modal>
  </div>
  
</template>

<script setup>
import { ref, computed} from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useSelectedPlanCard, useScreen } from '@/composables';
import WeButton from './WeButton'
import WeIcon from './WeIcon'
import WeInformationalCard from './WeInformationalCard'
import WeModal from './WeModal'
import WeSlider from './WeSlider'
import WePlanCard from './WePlanCard'

const store = useStore()

const isPlanModalOpen = ref(false)

const planType = ref('plans');

const isLoading = ref(false);

const togglePlanType = (type) => {
  planType.value = type
}

const { useSmallSelectedPlan, showInformationalCard } = useSelectedPlanCard()

const { isSmall } = useScreen()

const route = useRoute()

//selected plan card
const classes = computed(() => useSmallSelectedPlan.value ? 'py-3 px-4' : 'p-6')

const selectedPlan = computed(() => store.getters.getSelectedPlan)

const promoDescription = computed(() => selectedPlan.value.product?.promo_description || '')

const hasSelectedPlan = computed(() => Object.keys(selectedPlan.value).length)

const discount = computed(() => store.getters.getDiscount);

const hasPromoDescription = computed(() => Boolean(selectedPlan.value.product?.promo_description))
const hasOriginalPrice = computed(() => Boolean(selectedPlan.value.product?.original_price))
const hasPromoCodeDiscount = computed(() => Object.keys(discount.value || {}).length > 0)
const hasDiscount = computed(() => hasPromoCodeDiscount.value || (hasPromoDescription.value && hasOriginalPrice.value))

const originalPriceDisplay = computed(() => {
  const original = selectedPlan.value.product?.original_price
  if (original) return original

  const fallback = selectedPlan.value.product?.full_price
  if (fallback) return fallback

  return ''
})

const openModal = () => isPlanModalOpen.value = true

const closeModal = () => isPlanModalOpen.value = false

const sessionUuid = computed( () => store.state.selectedPlan.uuid )
const selectedCity = computed(()=> store.getters.getSelectedCity.slug) 

const changePlan = (plan) => {

  closeModal();

  isLoading.value = true

  store.dispatch('updatePlanOrCity', { 
    sessionUuid: sessionUuid.value,
    city: selectedCity.value,
    product: plan.id,
    type: plan.type,
  }).finally(()=>{
    isLoading.value = false
  })
    
}

const showChangePlanButton = computed(() => route.name == 'Availability')

const isBusiness = computed(() => {
  return (route.query.target || store.getters.getTarget) === 'business'
})

const hasCombo = computed(() => selectedPlan.value.product?.features?.length)

const plansList = computed(() => store.getters.getPlansList)

const sliderPositioning = computed(() => {
  if (isSmall.value) return availablePlans.value <= 2 ? 'justify-center' : ''

  return availablePlans.value.length <= 4 ? 'justify-center' : ''
})

const sliderListPositioning = computed(() => {
  if (isSmall.value) return plansList.value.length == 1 ? 'justify-center w-full' : 'gap-x-5'

  return plansList.value <= 4 ? 'justify-center w-full' : 'gap-x-5'
})

//WeButton props
const weButtonIconOptions = computed(() => {
  return {
    classes: 'p-0',
    size: '14px'
  }
})

const target = computed(()=>{
  return store.getters.getTarget ? store.getters.getTarget : 'plan'
})

const availablePlans = computed(()=>{
  return store.getters.getPlansList?.plans[target.value];
})

const availableCombos = computed(()=>{
  return store.getters.getPlansList?.combos[target.value];
})


</script>


<style lang="scss">
  .selectPlanModal {
    @media (max-height: 569px) {
      &__subtitle {
        display: none;
      }
    }  
  }
  .we-selected-plan-card > .business{
    @apply shadow-none
  }
</style>